export const toAbsoluteUrl = (pathname) => {
  return process.env.PUBLIC_URL + pathname;
};
